import { getDoc } from 'firebase/firestore';
import { getDocumentRef, handleFirebaseError } from './firebaseUtils';
import { workspaceApi } from './workspaceApi';
import { WorkspaceScope } from '../types/workspace';
import { SystemSettings, UpdateSystemSettingsRequest } from '../types/systemSettings';
import { DEFAULT_FAVICON } from '../config/sharingPolicy.mjs';

export async function getSystemSettings(scope: WorkspaceScope): Promise<SystemSettings | null> {
  if (scope.mode === 'public') {
    const data = await workspaceApi<{ settings: SystemSettings | null }>('public', scope, { identifier: scope.publicIdentifier });
    return data.settings;
  }
  const snapshot = await getDoc(getDocumentRef(scope, 'systemSettings', 'main'));
  if (!snapshot.exists()) return null;
  const data = snapshot.data();
  return { ...data, id: snapshot.id, createdAt: data.createdAt?.toDate() || new Date(), updatedAt: data.updatedAt?.toDate() || new Date() } as SystemSettings;
}
export async function upsertSystemSettings(scope: WorkspaceScope, data: Partial<UpdateSystemSettingsRequest>): Promise<{ success: boolean; error?: string }> {
  try { await workspaceApi('saveSettings', scope, { data }); return { success: true }; }
  catch (error) { return { success: false, error: handleFirebaseError(error) }; }
}
export async function initializeDefaultSystemSettings(scope: WorkspaceScope): Promise<{ success: boolean; error?: string }> {
  if (await getSystemSettings(scope)) return { success: true };
    const defaultSettings: UpdateSystemSettingsRequest = {
      siteName: '렌탈프로모션',
      defaultTitle: '렌탈프로모션 월간 소식',
      defaultDescription: '최신 렌탈 정보와 프로모션을 확인하세요',
      characterTheme: 'male',
      shareImageMode: 'theme',
      defaultImageUrl: '',
      faviconMode: 'default',
      faviconUrl: DEFAULT_FAVICON,
      // 프로모션 비활성화 시 안내 메시지 기본값
      inactivePromotionTitle: '프로모션 종료',
      inactivePromotionMessage: '죄송합니다. 해당 프로모션은 종료되었습니다.',
      inactivePromotionGuide: '담당자에게 현재 진행 중인 프로모션을 문의해주세요.',
      inactivePromotionButtonText: '돌아가기'
    };
    
  return upsertSystemSettings(scope, defaultSettings);
}
